import { render, staticRenderFns } from "./SurgeryReservationDate.vue?vue&type=template&id=4645e09e&scoped=true"
import script from "./SurgeryReservationDate.vue?vue&type=script&lang=js"
export * from "./SurgeryReservationDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4645e09e",
  null
  
)

export default component.exports